import { render, staticRenderFns } from "./t-orm-fields-content.vue?vue&type=template&id=644d954c&scoped=true&lang=pug"
import script from "./t-orm-fields-content.vue?vue&type=script&lang=js"
export * from "./t-orm-fields-content.vue?vue&type=script&lang=js"
import style0 from "./t-orm-fields-content.vue?vue&type=style&index=0&id=644d954c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d954c",
  null
  
)

export default component.exports